﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import VeilederGenerellDto from '../Models/VeilederGenerellDto';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';
import { valgReducer } from './Valg/Reducers';

const rootReducer = combineReducers<VeilederGenerellAppState>({
    valg: valgReducer,
    resultat: resultatReducer,
    epiContext: (
        state: EpiContext<VeilederGenerellDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederGenerellDto>,
    ): EpiContext<VeilederGenerellDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer
});

export type VeilederGenerellAppState = EpiAppStateMedSteg<VeilederGenerellDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
};

export default function configureStore(): Store<VeilederGenerellAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}
